import React, { FC, useEffect } from "react";
import "./CreateRequest.css";
import { Message } from "primereact/message";
import {useCreateReplacementResponseMutation} from "../../../api/refereeReplacementApi";
import { useSearchParams } from "react-router-dom";

export const Response: FC = () => {
    const [searchParams] = useSearchParams();

    const [createReplacementResponse, {isSuccess, isError, error}] = useCreateReplacementResponseMutation();

    // @ts-ignore
    const errorMessage = error?.data?.message;

    useEffect(() => {
        window.scrollTo(0, 0);

        if (searchParams.get("tokenId")) {
            createReplacementResponse({tokenId: searchParams.get("tokenId") ?? ''});
        }
    }, [searchParams]);

    return (
        <div className="flex justify-content-center p-2">
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "white", padding: 10, borderRadius: 10, minHeight: 400}} className="card flex align-items-center flex-column pt-6 px-3">
                {isSuccess && <>
                    <i className="pi pi-check-circle" style={{ fontSize: "5rem", color: "var(--green-500)" }}></i>
                    <Message style={{ width: "100%", fontWeight: "bold", marginTop: 20 }}
                             text="Dziękujemy za zgłoszenie! Już niedługo podejmiemy decyzję dotyczącą zastępstwa :)"
                             severity="success" />
                </>}
                {isError && <>
                    <i className="pi pi-times" style={{ fontSize: "5rem", color: "var(--red-500)" }}></i>
                    <Message style={{ width: "100%", fontWeight: "bold", marginTop: 20 }}
                             text={errorMessage}
                             severity="error" />
                </>}

            </div>
        </div>
    );
};

export default Response;